export const emailRegex =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

// eslint-disable-next-line no-useless-escape, max-len
export const validateEmail = value =>
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
    value,
  );
export const validateEmojiRegex = value =>
  !new RegExp(
    /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g,
  ).test(value);
export const EmojiRegex = new RegExp(
  /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi,
);

export const validateTelephone = value =>
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{2,7}$/.test(value);
export const validateInternationalTelephone = value =>
  /^(\+[0-9\s]{1,5}\s|\(\+[0-9\s]{1,5}\)\s{0,1})?(\d+\s?)*\d{8,}$/.test(value);
export const validateNotEmpty = value => !!(value && value.length > 0);

export const validateYear = (value, yearStartOffset, yearEndOffset) => {
  const currentYear = new Date().getFullYear();
  return value >= currentYear + yearStartOffset && value <= currentYear + yearEndOffset;
};

export const validateDayInMonth = (day, month, year) => {
  const dayValue = parseInt(day, 10);
  const monthValue = parseInt(month, 10);
  const yearValue = parseInt(year, 10);
  let isValid = dayValue <= 28;

  if ([1, 3, 5, 7, 8, 10, 12].indexOf(monthValue) !== -1) {
    // Months with 31 days
    isValid = dayValue <= 31;
  } else if ([4, 6, 9, 11].indexOf(monthValue) !== -1) {
    // Months with 30 days
    isValid = dayValue <= 30;
  } else if (dayValue === 29) {
    isValid = yearValue ? yearValue % 4 === 0 : true;
  }

  return isValid;
};

export const validateDay = (day, month, year) => day > 0 && validateDayInMonth(day, month, year);
